import featuresPage from "../featuresPage/FeaturesPage"

new featuresPage();